import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { DNABox, DNACard, DNAIcon, DNAText, useTheme, util } from '@alucio/lux-ui'
import { FolderORM } from 'src/types/types'
import { useAppSettings } from 'src/state/context/AppSettings'
import { GRID_LIST_STYLES_VARIANTS_CONFIGS } from 'src/screens/MyFolders/constants'
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types'
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'

const styles = StyleSheet.create({
  cardStyle: {
    backgroundColor: 'transparent',
  },
  folderContainer: {
    minWidth: 76,
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleText: {
    marginLeft: 24,
  },
})

export const DNACustomDeckFolderRow: DNARowsComponent<FolderORM> = (props) => {
  const {
    ORM: folderORM,
    onPress,
  } = props

  const theme = useTheme()
  const { deviceMode } = useAppSettings()

  const iconColor = useMemo(() => colors['color-ui2-brand-200'], []);

  const allStyle = {
    paddingHorizontal: theme['row-padding-horizontal'],
    paddingVertical: theme['row-padding-vertical'],
  }

  return (
    <DNACard
      appearance="flat"
      style={util.mergeStyles(props, allStyle, styles.cardStyle)}
      interactive="pressable"
      onPress={() => onPress?.(folderORM)}
    >
      <DNABox
        testID="folder-row"
        childFill={0}
        spacing="between"
        alignY="center"
      >
        <DNABox alignY="center" childFill={1}>
          <DNABox style={styles.folderContainer}>
            <DNAIcon.Styled
              name="folder-simple-fill"
              color={iconColor}
              width={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_ICON[deviceMode].width}
              height={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_ICON[deviceMode].height}
            />
          </DNABox>
          <DNAText testID="folder-item-title" b1 numberOfLines={2} style={styles.titleText}>
            { folderORM.model.name }
          </DNAText>
        </DNABox>
      </DNABox>
    </DNACard>
  )
}

export default DNACustomDeckFolderRow
